import React, { useContext } from 'react'
import { ProductDetailsContext } from './ProductDetailsContext'
import { pathOr } from 'ramda'
import '@reach/listbox/styles.css'

const ProductDetailsMatrixDropdown = ({ id, matrixItems, product, uom }) => {
  const productDetailsProps = useContext(ProductDetailsContext)
  const defaultItem = matrixItems[0].id
  const matrixProducts = pathOr(false, ['product', 'data', 'children'], productDetailsProps)
  const selectedProduct = matrixProducts.find(item => item.id === product.id)
  const selectedProductValue = selectedProduct.id

  const handleChange = newValue => {
    matrixItems.forEach(item => {
      if (item.id === newValue) {
        productDetailsProps.history.push(
          item.urlComponent + `?uom=${Object.values(item.matrixDetails)[0]}`,
        )
      }
    })
  }

  const options = matrixItems
    .filter(item => item.matrixDetails)
    .map(item => ({
      text: Object.values(item.matrixDetails)[0],
      value: item.id,
      disabled: false,
      attributes: item.attributes?.["Sold By"]
    }))

  return (
    <div className="product-details__qty-type">
      <span id={id} className="visually-hidden">
        Select Your Unit Type
      </span>
      <div className="product-details__qty-buttons">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`product-details__qty-button ${selectedProductValue === option.value ? 'product-details__qty-button--active' : ''}`}
            onClick={() => handleChange(option.value)}
            aria-pressed={selectedProductValue === option.value}
            disabled={option.disabled}
            style={{width: '83px', display: 'flex', flexDirection: 'column', alignItems: 'center',padding: '8px'}}
          >
            <span style={{textAlign: 'center'}}>{option.text}</span>
            <span style={{textAlign: 'center',fontSize: '12px'}}>{option.attributes}</span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default ProductDetailsMatrixDropdown
